import { z } from 'zod/v4'
import { DataType } from 'skedyul-db/enums'
import {
  CreateFieldDefinitionOptionSchema,
  GetFieldDefinitionOptionSchema,
} from '../features/options/resources/types'
import {
  GetFieldDefinitionNormalizationSchema,
  CreateFieldDefinitionNormalizationSchema,
} from '../features/normalizations/resources/types'

export const CreateFieldDefinitionSchema = z.object({
  handle: z.string().min(1),
  type: z.nativeEnum(DataType),
  shape: z.unknown().optional().nullable(),
  regexPattern: z.string().optional().nullable(),
  limitChoices: z.number().optional().nullable(),
  options: z.array(CreateFieldDefinitionOptionSchema),
  normalizations: z.array(CreateFieldDefinitionNormalizationSchema).default([]),
  isPrivate: z.boolean().default(true),
})

export const UpdateFieldDefinitionSchema = CreateFieldDefinitionSchema.omit({
  options: true,
  type: true,
  isPrivate: true,
}).extend({
  id: z.string(),
  workplaceId: z.string(),
  handle: z.string().min(1),
})

export const GetFieldDefinitionSchema = z.object({
  id: z.string(),
  handle: z.string(),
  type: z.enum([
    'LONG_STRING',
    'STRING',
    'NUMBER',
    'BOOLEAN',
    'DATE',
    'DATE_TIME',
    'TIME',
    'FILE',
    'IMAGE',
    'RELATION',
    'OBJECT',
  ]),
  shape: z.unknown().optional().nullable(),
  isPrivate: z.boolean(),
  regexPattern: z.string().optional().nullable(),
  lazyLoadingEnabled: z.boolean(),
  limitChoices: z.number().optional().nullable(),
  hasOptions: z.boolean(),
  options: z.array(GetFieldDefinitionOptionSchema),
  normalizations: z.array(GetFieldDefinitionNormalizationSchema),
})

export type CreateFieldDefinition = z.infer<typeof CreateFieldDefinitionSchema>
export type GetFieldDefinition = z.infer<typeof GetFieldDefinitionSchema>
